<template>
    <el-card shadow="always">
        <div class="popover-container">
            <!-- <div class="popover-chart">
                <PieCharts :pieData="pieData" :total="total.num" id="rank-pie"></PieCharts>
            </div>
            <div class="popover-legend">
                <PopoverLegend v-for="(item, index) in data" :key="index" :item="item" ></PopoverLegend>   
            </div> -->
            <div class="title" >{{time==0?"今日":time==1?"本周":"本月"}}共<i>{{data.sum?data.sum:0}}</i>件</div>
            <div class="cont row-center" style="justify-content: space-between;align-items: start;">
                <div class="land">
                    <div class="item">操作命令：<i>{{data.operation?data.operation:0}}</i></div>
                    <div class="item">越限异常：<i>{{data.overrun?data.overrun:0}}</i></div>
                    <div class="item">故障报警：<i>{{data.fault?data.fault:0}}</i></div>
                    <div class="item">其他告警：<i>{{data.other?data.other:0}}</i></div>
                </div>
                <div class="land">
                    <div class="item">信息通报：<i>{{data.messageNotice?data.messageNotice:0}}</i></div>
                    <div class="item">开关变位：<i>{{data.switchDisplacement?data.switchDisplacement:0}}</i></div>
                    <div class="item">保护动作：<i>{{data.protections?data.protections:0}}</i></div>
                </div>
            </div>
        </div>
    </el-card>
</template>

<script>
import { number } from 'echarts';
import PieCharts from '../statistics/PieCharts';
import PopoverLegend from './PopoverLegend';

export default {
    props: {
        time:Number,
        data: {
            type: Object,
            default:{
                fault: 0 ,
                hiddenDanger: 0,
                messageNotice: 0,
                notice: 0,
                operation: 0,
                other: 0 ,
                overrun: 0,
                protections: 0,
                sum: 0,
                switchDisplacement: 0,
                urgent: 0 
            }
        }
    },
    components: {
        PieCharts,
        PopoverLegend
    },                                                              
    computed: {
        // pieData: function () {
        //     return this.data.map(item => {
        //         return {
        //             name: item.name,
        //             value: item.num,
        //             itemStyle: {
        //                 color: item.color
        //             }
        //         }
        //     })
        // },
        // total: function () {
        //     return this.data.reduce((prev, current) => {
        //         return {
        //             num: prev.num + current.num
        //         }
        //     })
        // }
    },
}
</script>

<style lang="less" scoped>
.popover-container {
    // display: flex;
    width: 426px;
    height: 232px;
    &::before{
        content: '';
        background: url('../../../assets/img/down2.png');
        width: 26px;
        height: 13px;
        position: absolute;
        top: 100%;
        left: 50%;
        margin-top: -3px;
        margin-left: -13px;
        filter: drop-shadow(0px 8px 5px rgba(0, 0, 0, .08));
    }
    i{
        font-style: initial;
    }
    .title{
        height: 64px;
        background:rgba(0, 43, 102, 0.04);
        border-radius: 8px;
        line-height: 64px;
        text-align: center;
        font-size: 16px;
        color: #666666;
        i{
            color: #0D94FF;
            font-size: 24px;
            font-weight: bold;
            margin: 0 15px;
        }
    }
    .cont{
        font-size: 16px;
        color: #666666;
        margin-top: 24px;
        i{
            color: #0D94FF;
        }
        .item{
            // padding-left: 20px;
            line-height: 35px;
        }
        .item::before{
            content: '';
            border: 2px solid #CCCCCC;
            height: 16px;
            margin-right: 5px;
        }
        .land{
            width: 40%;
        }
    }
    .popover-chart {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 100%;
        width: 50%;
    }

    .popover-legend {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        min-height: 100%;
        width: 50%;

        padding-left: 24rem;
    }

}
</style>